const CLINICAL_ACRONYMS = new Map([
  ["ent", "ENT"],
  ["hiv", "HIV"],
  ["icu", "ICU"],
  ["ob", "OB"],
  ["tb", "TB"],
]);

const LOWERCASE_CONNECTORS = new Set(["and", "for", "in", "of", "the"]);

function formatSpecialtyToken(token, index) {
  const match = String(token || "").match(/^(\W*)([\p{L}\p{N}]+)(\W*)$/u);
  if (!match) return token;

  const [, prefix, core, suffix] = match;
  const normalized = core.toLocaleLowerCase();
  const acronym = CLINICAL_ACRONYMS.get(normalized);
  if (acronym) return `${prefix}${acronym}${suffix}`;

  const lettersOnly = core.replace(/[^\p{L}]/gu, "");
  const isUniformCase =
    lettersOnly &&
    (lettersOnly === lettersOnly.toLocaleLowerCase() ||
      lettersOnly === lettersOnly.toLocaleUpperCase());
  if (!isUniformCase) return token;

  if (index > 0 && LOWERCASE_CONNECTORS.has(normalized)) {
    return `${prefix}${normalized}${suffix}`;
  }
  return `${prefix}${normalized.charAt(0).toLocaleUpperCase()}${normalized.slice(1)}${suffix}`;
}

/**
 * Shared clinician-specialty presentation rule. This changes display casing
 * only and never rewrites the stored taxonomy/profile value.
 */
export function formatClinicianSpecialtyLabel(value, fallback = "Specialty not listed") {
  const raw = String(value || "").trim();
  if (!raw) return String(fallback || "").trim();

  let wordIndex = 0;
  return raw
    .split(/(\s+|\/|–|—|-)/)
    .map((part) => {
      if (!part || /^(\s+|\/|–|—|-)$/.test(part)) return part;
      const formatted = formatSpecialtyToken(part, wordIndex);
      wordIndex += 1;
      return formatted;
    })
    .join("");
}
